<template>
  <div class="row keyword-filters">
    <div
      class="keyword-filters__input keyword-filters__input--offset columns large-4 medium-12 small-12"
    >
      <ElInput
        :value="search"
        :placeholder="searchPlaceholder"
        @input="updateSearch"
      />
    </div>
    <div class="keyword-filters__input columns large-3 medium-12 small-12">
      <RangeFilter
        :value="range"
        :default-filters="bidRangeFilters"
        @input="updateRange"
      />
    </div>
  </div>
</template>

<script>
import { getFilters } from '@@/advertisement/common/utils/rangeFilters';

import RangeFilter from '@@/common/RangeFilter';

export default {
  name: 'KeywordFilters',
  components: {
    RangeFilter,
  },
  props: {
    search: {
      type: String,
      required: true,
    },
    range: {
      type: String,
      required: true,
    },
    searchPlaceholder: {
      type: String,
      required: true,
    },
  },
  computed: {
    bidRangeFilters() {
      const rangeFilters = getFilters();
      return rangeFilters;
    },
  },
  methods: {
    updateSearch(search) {
      this.$emit('update:search', search);
    },
    updateRange(range) {
      this.$emit('update:range', range);
    },
  },
};
</script>
<style lang="scss">
.keyword-filters {
  &__input {
    margin-bottom: $global-margin;

    &--offset {
      margin-right: $global-margin * 2;
      @include rtl() {
        margin-left: $global-margin * 2;
        margin-right: 0;
      }
    }
  }
}
</style>
